import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import invalidTargetings from './validation'

export default {
  data() {
    return { targetingValidationAttempted: false }
  },
  computed: {
    targetingErrors() {
      if (!this.targetingValidationAttempted) return {}
      return invalidTargetings(this.targetingsForValidation).reduce((errors, key) => {
        const label = { date_num: 'date_num.label', site: 'sites' }[key] || key
        const target = this.$t(`banners.targetings.${label}`)
        const message = key === 'date' ? 'dates_required' : 'value_required'
        const text = key === 'capping' ? this.$t('campaign_targeting_validation.positive_hours')
          : this.$t(`campaign_targeting_validation.${message}`, { target })
        return { ...errors, [key]: text }
      }, {})
    },
    targetingsForValidation() {
      return this.targetings
    },
  },
  methods: {
    validateTargetings() {
      this.targetingValidationAttempted = true
      const messages = Object.values(this.targetingErrors)
      if (!messages.length) return true
      if (this.$refs.targetingsTab) this.$refs.targetingsTab.activate()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('campaign_targeting_validation.title'),
          text: messages.join('\n'),
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      }, { id: 'campaign-targeting-validation' })
      return false
    },
  },
}
